export class NexuClasses {
  public static colors: string[] = [
    "ice-blue",
    "pale-grey",
    "light-grey",
    "night-blue",
    "slate-grey",
    "pinkish-grey",
    "light-navy-blue",
    "warm-blue",
    "marine",
    "success",
    "success",
    "green",
    "warning",
    "yellow",
    "lightish-red",
    "error",
    "red",
    "pale-red",
    "greyish-brown",
    "white",
    "black",
    "warning-yellow",
  ];
}
